
import * as customProviderRuntime$yxC0CkOJxz from '/vercel/path0/utils/custom-provider.js'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "customProvider",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['customProvider']: { provider: customProviderRuntime$yxC0CkOJxz, defaults: {} }
}
        